export const CONTACT = {
    phone: "+44 2046 402840",
    phoneHref: "tel:+442046402840",
    email: "admin@xtremeprotection.uk",
    emailHref: "mailto:admin@xtremeprotection.uk",
};

// Production domain — canonical tags and og:url are emitted site-wide from this.
export const SITE_URL = "https://scotlandsecurity.uk";

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1546617605-31567bc8c7d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxlZGluYnVyZ2glMjBuaWdodCUyMGNpdHklMjBhcmNoaXRlY3R1cmUlMjBkYXJrfGVufDB8fHx8MTc5MTYwMjQ2NHww&ixlib=rb-4.1.0&q=85",
    glasgow: "https://images.unsplash.com/photo-1646867798986-feec380fe3b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxnbGFzZ293JTIwc2t5bGluZSUyMG5pZ2h0JTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc5MTYwMjQ2NHww&ixlib=rb-4.1.0&q=85",
    edinburgh: "https://images.unsplash.com/photo-1519206703305-f4567b3b2885?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxlZGluYnVyZ2glMjBuaWdodCUyMGNpdHklMjBhcmNoaXRlY3R1cmUlMjBkYXJrfGVufDB8fHx8MTc5MTYwMjQ2NHww&ixlib=rb-4.1.0&q=85",
    patrol: "https://images.unsplash.com/photo-1618371690240-e0d46eead4b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxzZWN1cml0eSUyMGd1YXJkJTIwdW5pZm9ybSUyMGVhcnBpZWNlJTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc5MTYwODQzOHww&ixlib=rb-4.1.0&q=85",
    cctv: "https://images.unsplash.com/photo-1708807472445-d33589e6b090?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxjY3R2JTIwY29udHJvbCUyMHJvb20lMjBtb25pdG9yaW5nJTIwc2NyZWVucyUyMGRhcmt8ZW58MHx8fHwxNzkxNjAyNDcxfDA&ixlib=rb-4.1.0&q=85",
    k9: "https://images.unsplash.com/photo-1620135323430-9e28fda3ea7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxnZXJtYW4lMjBzaGVwaGVyZCUyMHNlY3VyaXR5JTIwZG9nJTIwaGFuZGxlciUyMG5pZ2h0fGVufDB8fHx8MTc5MTYwMjQ3MXww&ixlib=rb-4.1.0&q=85",
    construction: "https://images.unsplash.com/photo-1685953055318-0080d30a4f67?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjBzaXRlJTIwbmlnaHQlMjBsaWdodHMlMjBzaWxob3VldHRlfGVufDB8fHx8MTc5MTYwMjQ3MXww&ixlib=rb-4.1.0&q=85",
};

export const CITY_IMAGES = [
    IMAGES.glasgow,
    IMAGES.edinburgh,
    IMAGES.hero,
    IMAGES.construction,
    IMAGES.patrol,
    IMAGES.cctv,
    IMAGES.k9,
];

export const MARQUEE_ITEMS = [
    "Manned Guarding Scotland",
    "Security Guards Glasgow",
    "Door Supervisors Edinburgh",
    "CCTV Monitoring Aberdeen",
    "Mobile Patrols Dundee",
    "Event Security Scotland",
    "Construction Site Security",
    "Retail Security Glasgow",
    "Key Holding & Alarm Response",
    "K9 Security Dog Handlers",
    "Close Protection Scotland",
    "SIA Licensed Security Company",
    "24/7 Security Services Scotland",
    "Corporate Security Edinburgh",
    "Vacant Property Security",
];

export const HOME_FAQS = [
    {
        q: "What security services does Xtreme Protection provide in Scotland?",
        a: "We deliver 17 specialist services across Scotland: manned guarding, door supervision, CCTV monitoring, mobile security patrols, event security, construction site security, retail security, corporate security, concierge security, key holding and alarm response, close protection, warehouse and industrial security, K9 dog handlers, vacant property security, hotel security, healthcare security and school and campus security — all delivered by SIA-licensed, BS 7858 vetted officers with verified digital reporting.",
    },
    {
        q: "Which parts of Scotland do you cover?",
        a: "We operate in 46 Scottish towns and cities — from Glasgow, Edinburgh, Aberdeen and Dundee to Inverness, Oban, St Andrews, Hawick and the islands of Orkney, Shetland, Skye, Bute and the Western Isles — with 24/7 regional command coverage from the Borders to the Northern Isles.",
    },
    {
        q: "Are your security officers SIA licensed?",
        a: "Yes, without exception. Every officer holds the correct Security Industry Authority licence for their role, is vetted to BS 7858, first-aid trained and briefed under site-specific assignment instructions before their first shift.",
    },
    {
        q: "How quickly can security be deployed in Scotland?",
        a: "For urgent requirements we aim to have licensed officers on site within 24 hours. Rapid-deployment CCTV towers are usually installed within days of survey, and mobile patrol or key holding contracts can begin immediately.",
    },
    {
        q: "Do you provide 24 hour security?",
        a: "Yes — our operations run 24 hours a day, 365 days a year. Static guarding, mobile patrols, CCTV monitoring and alarm response are all available around the clock, coordinated by our Scottish command centre.",
    },
    {
        q: "Which industries do you protect?",
        a: "We protect construction and housebuilding, retail and shopping centres, logistics and distribution, corporate offices and business parks, hospitality, hotels and licensed venues, healthcare facilities, schools and campuses and vacant property portfolios. Every package starts from a fresh risk assessment, not an off-the-shelf template.",
    },
];

export const cityFaqs = (name) => [
    {
        q: `What security services do you provide in ${name}?`,
        a: `We deliver all 17 specialist services in ${name}: manned guarding, door supervision, CCTV monitoring, mobile patrols, event security, construction site security, retail security, corporate and concierge security, key holding and alarm response, close protection, warehouse security, K9 dog handlers, vacant property security, hotel, healthcare and campus security.`,
    },
    {
        q: `How quickly can you deploy security guards in ${name}?`,
        a: `For urgent requirements in ${name} we aim to have SIA-licensed officers on site within 24 hours. Mobile patrol and key holding contracts can begin immediately, and rapid-deployment CCTV towers are typically installed within days of survey.`,
    },
    {
        q: `Are your ${name} security officers licensed and vetted?`,
        a: `Yes. Every officer deployed in ${name} holds a valid SIA licence for their role, is vetted to BS 7858, first-aid trained and works to site-specific assignment instructions with GPS-verified patrol reporting.`,
    },
];
